<div class="modal-header">
  <h6 class="modal-title" id="modal-basic-title">{{"Update Email"|translate}}</h6>
  <button type="button" class="btn-close" aria-label="Close" (click)="dismissModal()">
  </button>
</div>
<div class="modal-body">
  <div class="bg-form-content p-4">
    <form class="change-password-form" ngForm [formGroup]="updateForm" novalidate>
      <div class="field-group mb-3">
        <label>{{"Current Email"|translate}}</label>
        <input type="text" formControlName="old_email" class="form-control light-mode-form"
          [readonly]="show.newEmailOTPfield || show.oldEmailOTPfield" />
        <val-errors controlName="old_email">
          <ng-template valError="required">
            <small class="form-error text-danger">
              {{"Please enter current email"|translate}}.
            </small>
          </ng-template>
          <ng-template valError="invalidEmail">
            <small class="form-error text-danger">
              {{"Please enter valid current email"|translate}}.
            </small>
          </ng-template>
        </val-errors>
      </div>
      <div class="field-group mb-3">
        <label>{{"New Email"|translate}}</label>&nbsp;
        <small class="lms-text-light-green" *ngIf="!show.verifyNewEmail">{{ "verified" | translate }}</small>
        <input type="text" formControlName="new_email" class="form-control light-mode-form"
          [readonly]="show.newEmailOTPfield || show.oldEmailOTPfield" />
        <val-errors controlName="new_email">
          <ng-template valError="required">
            <small class="form-error text-danger">
              {{"Please enter new email"|translate}}.
            </small>
          </ng-template>
          <ng-template valError="invalidEmail">
            <small class="form-error text-danger">
              {{"Please enter valid new email"|translate}}.
            </small>
          </ng-template>
        </val-errors>
        <small class="form-error text-danger" *ngIf="updateForm.get('new_email')?.valid &&
            updateForm.get('old_email')?.valid && updateForm.value?.new_email == updateForm.value?.old_email">
          {{"Your new email must be different from your old email"|translate}}.
        </small>
      </div>
      <div class="field-group mb-3" *ngIf="show.newEmailOTPfield">
        <p>
          {{'Please enter verification code sent to your new email'|translate}}.
        </p>
        <label>{{"Verification Code"|translate}}</label>
        <ng-otp-input formControlName="new_email_otp" [config]="config"></ng-otp-input>
        <div class="text-muted">
          <small *ngIf="countdown > 0">
            {{"Didn't get the OTP?"|translate}} {{ "Resend in" | translate }} {{ countdown }}s
          </small>
          <a href="javascript:void(0)" (click)="getOTP('new-email')" *ngIf="countdown === 0">
            <small>{{ "Resend OTP" | translate }}</small>
          </a>
        </div>
      </div>
      <div class="field-group mb-3" *ngIf="show.oldEmailOTPfield">
        <p *ngIf="userInfo.mfa_type=='APP'">
          {{'Enter the code from your two-factor authenticator app'|translate}}.
        </p>
        <p *ngIf="userInfo.mfa_type=='SMS'">
          {{'Please enter verification code sent to your mobile number'|translate}} {{userInfo?.masked_mobile_number}}.
        </p>
        <label>{{"Verification Code"|translate}}</label>
        <ng-otp-input formControlName="old_email_otp" [config]="config"></ng-otp-input>
        <div class="text-muted" *ngIf="userInfo?.mfa_type!='APP'">
          <small *ngIf="countdown > 0">
            {{"Didn't get the OTP?"|translate}} {{ "Resend in" | translate }} {{ countdown }}s
          </small>
          <a href="javascript:void(0)" (click)="getOTP()" *ngIf="countdown === 0">
            <small>{{ "Resend OTP" | translate }}</small>
          </a>
        </div>
      </div>
      <div>
        <small class="form-error text-danger" *ngIf="messageData?.errorArr?.length">
          <div *ngFor="let item of messageData?.errorArr; let i=index;" class="mt-3">
            <li>{{item}}</li>
          </div>
        </small>
        <!-- <small class="lms-text-light-green" *ngIf="messageData?.verified">
          <li class="fs-15">
            {{messageData.verified}}
            <ng-container *ngIf="redirectData?.message">
              {{redirectData.message}}{{redirectData.countdown}}s.
            </ng-container>
          </li>
        </small> -->
      </div>
      <div class="mt-3" *ngIf="show.verifyNewEmail && !show.newEmailOTPfield">
        <button class="btn btn-primary d-block w-100 text-uppercase" (click)="getOTP('new-email')">
          {{"Verify New Email"|translate}}
        </button>
      </div>
      <div class="mt-3" *ngIf="show.newEmailOTPfield">
        <button class="btn btn-primary d-block w-100 text-uppercase" (click)="verifyNewEmailOTP()"
          [disabled]="updateForm.controls.new_email_otp.invalid">
          {{userInfo?.enable_2fa=='NO' ? ("Update Email"|translate ): ("Verify OTP"|translate)}}
        </button>
      </div>
      <div class="mt-3" *ngIf="!show.verifyOldEmailOTP">
        <button class="btn btn-primary d-block w-100 text-uppercase" (click)="onSubmit()"
          [disabled]="updateForm.controls.old_email_otp.invalid || redirectData.message">
          {{"Update Email"|translate}}
        </button>
      </div>
    </form>
  </div>
</div>